import { Box, Button, CircularProgress, Drawer, Stack } from '@mui/material'
import PlusIcon from '../../../../common/icons/plusIcon'
import React, { useState } from 'react'
import { useAddSamlProviderMutation } from '../../../../api/settings.api'
import AdapterForm from './AdapterForm'
import { CloseDrawer } from '../../../../common/icons/closeDrawer'

export default function AddAdapterButton({ variant = 'contained' }) {
  const [openModal, setOpenModal] = useState(false)
  const [newAdapter, setNewAdapter] = useState(null)
  const [addProvider, { isLoading }] = useAddSamlProviderMutation()

  const handleClick = async () => {
    try {
      const result = await addProvider().unwrap()
      setNewAdapter(result)
      setOpenModal(true)
    } catch (error) {
      console.error('Failed to create provider:', error)
    }
  }

  const handleSubmit = async values => {
    try {
      await addProvider(values).unwrap()
      setOpenModal(false)
    } catch (error) {
      console.error('Failed to update provider:', error)
    }
  }

  return (
    <>
      <Button
        variant={variant}
        sx={{
          background: variant === 'contained' ? '#6123FF' : 'transparent',
          borderRadius: '12px',
          fontFamily: 'Plus Jakarta Sans',
          color: variant === 'contained' ? '#fff' : '#6123FF',
          textTransform: 'none',
          width: 230,
          border: variant === 'outlined' ? '1px solid #6123FF' : 'none'
        }}
        disabled={isLoading}
        startIcon={
          isLoading ? (
            <CircularProgress size={18} />
          ) : (
            <PlusIcon color={variant === 'contained' ? '#ffffff' : '#6123FF'} />
          )
        }
        onClick={handleClick}
      >
        Add Adapter
      </Button>
      <Drawer anchor='right' open={openModal && !!newAdapter} onClose={() => setOpenModal(false)}>
        <Stack
          sx={{
            padding: '32px',
            rowGap: 2
          }}
        >
          <Box display='flex' justifyContent='space-between' alignItems='center'>
            <h2>SAML 2.0 Configuration</h2>
            <div
              style={{
                position: 'fixed',
                top: '24px',
                right: '700px',
                cursor: 'pointer'
              }}
              onClick={() => {
                setOpenModal(false)
              }}
            >
              <CloseDrawer />
            </div>
          </Box>

          <AdapterForm adapter={newAdapter} onSubmit={handleSubmit} onClose={() => setOpenModal(false)} />
        </Stack>
      </Drawer>
    </>
  )
}
